import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { INavData, SidebarNavComponent } from '@coreui/angular-pro';
import { CustomMenuService } from '@application/services/curstomMenu.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as diacritics from 'diacritics';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent implements OnInit {
  @ViewChild('sidebarData')
  sidebarData!: SidebarNavComponent;

  accion: any;
  public navItemsMapper: INavData[] = [];

  public navItems: INavData[] = [];
  public filteredNavs: INavData[] = [];

  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  public searchMenu: FormGroup;

  constructor(
    private menuService: CustomMenuService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.navItems = this.menuService.getMenus();

    for (let index = this.navItems.length-1; index >= 0; index--) {
      const element = this.navItems[index];
      if(element.children != null){
        for (let j = element.children?.length-1; j >= 0; j--) {
          const element2 = element.children[j];
          if(element2.children?.length == 0){
            element.children.splice(j, 1);
          }
        }
      }
      if(element.children?.length == 0){
        this.navItems.splice(index, 1);
      }
    }

    this.filteredNavs = JSON.parse(JSON.stringify(this.navItems));

    this.searchMenu = this.formBuilder.group({
      search: [null, Validators.required]
    });

    this.searchMenu.get('search')?.valueChanges.subscribe(value => {
      this.filterItems(value);
    });
  }

  ngOnInit(): void {
  }

  filterItems(searchText: string) {
    const normalizedSearchText = this.normalizeText(searchText.toLowerCase());

    this.filteredNavs.forEach(item => {
      const normalizedItemName = this.normalizeText(item.name?.toLowerCase());
      if (normalizedItemName.includes(normalizedSearchText)) {
        item.attributes = {
          'hidden': false
        };
      } else {
        item.attributes = {
          'hidden': true
        };
      }
      if (item.children && item.children.length > 0) {
        item.children.forEach(child => {
          const normalizedChildName = this.normalizeText(child.name?.toLowerCase());
          if (normalizedChildName.includes(normalizedSearchText)) {
            child.attributes = {
              'hidden': false
            };
            item.attributes = {
              'hidden': false
            };
          } else {
            child.attributes = {
              'hidden': true
            };
          }
          if (child.children && child.children.length > 0) {
            child.children.forEach(child2 => {
              const normalizedChildName = this.normalizeText(child2.name?.toLowerCase());
              if (normalizedChildName.includes(normalizedSearchText)) {
                child2.attributes = {
                  'hidden': false
                };
                child.attributes = {
                  'hidden': false
                };
                item.attributes = {
                  'hidden': false
                };
              } else {
                child2.attributes = {
                  'hidden': true
                };
              }
            });
          }
        });
      }
    });
  }

  resetFilter(){
    this.searchMenu.reset();
    this.filteredNavs = JSON.parse(JSON.stringify(this.navItems));
  }

  normalizeText(text: string = ''): string {
    return diacritics.remove(text);
  }

}
